HeroSlider = {
    init() {
        const heroSlider = document.getElementById('heroSlider')

        if (heroSlider) {
            const heroSlides = heroSlider.querySelectorAll('img');
            let currentSlide = 0;
            setInterval(() => {
                heroSlides[currentSlide].classList.remove('active');
                if (heroSlides[currentSlide + 1]) {
                    currentSlide++;
                } else {
                    currentSlide = 0;
                }
                heroSlides[currentSlide].classList.add('active');
            }, 3700)
        }
    }
}
export let HeroSlider;